(function () {
  "use strict";

  var SECTION_SELECTOR = "[data-wb-faqs]";

  function initFaqs(section) {
    if (!section || section.__wbFaqsInit) return;

    var triggers = section.querySelectorAll(".wb-faqs__trigger");
    var tabs = section.querySelectorAll(".wb-faqs__tab");
    var items = section.querySelectorAll(".wb-faqs__item");
    var tabsEnabled = section.getAttribute("data-tabs-enabled") === "true";
    var singleOpen = section.getAttribute("data-single-open") === "true";

    if (!items.length) return;

    section.__wbFaqsInit = true;

    function closeItem(item) {
      var trigger = item.querySelector(".wb-faqs__trigger");
      item.classList.remove("is-active");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    }

    function openItem(item) {
      var trigger = item.querySelector(".wb-faqs__trigger");
      item.classList.add("is-active");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
    }

    function visibleItems() {
      return Array.prototype.slice.call(items).filter(function (item) {
        return !item.classList.contains("is-hidden");
      });
    }

    function activateTab(tab) {
      var target = tab.getAttribute("data-target");
      var firstVisible = null;

      tabs.forEach(function (item) {
        item.classList.remove("is-active");
        item.setAttribute("aria-selected", "false");
      });

      tab.classList.add("is-active");
      tab.setAttribute("aria-selected", "true");

      items.forEach(function (item) {
        closeItem(item);

        if (item.getAttribute("data-tab") === target) {
          item.classList.remove("is-hidden");
          if (!firstVisible) firstVisible = item;
        } else {
          item.classList.add("is-hidden");
        }
      });

      if (firstVisible) openItem(firstVisible);
    }

    if (tabsEnabled && tabs.length) {
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          activateTab(tab);
        });
      });

      activateTab(tabs[0]);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest(".wb-faqs__item");
        if (!item) return;

        var isActive = item.classList.contains("is-active");

        if (singleOpen) {
          visibleItems().forEach(function (otherItem) {
            if (otherItem !== item) closeItem(otherItem);
          });
        }

        if (isActive) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initFaqs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initFaqs(section);
  });
})();